import { render, staticRenderFns } from "./ArticleRibbons.vue?vue&type=template&id=174c54e3&scoped=true"
import script from "./ArticleRibbons.vue?vue&type=script&lang=ts"
export * from "./ArticleRibbons.vue?vue&type=script&lang=ts"
import style0 from "./ArticleRibbons.vue?vue&type=style&index=0&id=174c54e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174c54e3",
  null
  
)

export default component.exports